import { render } from "./kullaniciCard.vue?vue&type=template&id=b6f22b1a"
import script from "./kullaniciCard.vue?vue&type=script&lang=js"
export * from "./kullaniciCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__